import { Injectable } from '@angular/core';
import { ProductServiceInterface } from '@app/models/interfaces/product-service.interface';
import { TaqmanSearchResponseInterface } from '@app/models/responses/taqman-search-response.interface';
import { CNVProductApiInterface } from '@app/products/cnv/models/interfaces/cnv-product-api.interface';
import { CNVProductInterface } from '../models/interfaces/cnv-product.interface';

@Injectable({providedIn: 'root'})
export class CNVProductService implements ProductServiceInterface {

    makeProductFromSearchResult(searchResult: TaqmanSearchResponseInterface): CNVProductInterface[] {

        return searchResult.products.map((product: CNVProductApiInterface) => {

            // TODO: Map this correctly once the API is ready
            const newProduct: CNVProductInterface = {
                alleleFreq: product.alleleFreq,
                ampliconLength: product.ampliconLength,
                assayDesign: product.assayDesign,
                availability: product.availability,
                cytoband: product.cytoband,
                defaultCatalogNum: product.defaultCatalogNum,
                defaultDye: product.defaultDye,
                defaultSize: product.defaultSize,
                discontinued: product.discontinued,
                dyeSizeData: product.dyeSizeData,
                genBankMrnas: product.genBankMrnas,
                gene: product.gene,
                geneAliases: product.geneAliases,
                geneNames: product.geneNames,
                geneSymbol: product.geneSymbol,
                isQualified: product.isQualified,
                location: product.location,
                packageId: product.packageId,
                plateSubType: product.plateSubType,
                pretested: product.pretested,
                productID: product.productID,
                productName: product.productName,
                productSubType: product.productSubType,
                productType: product.productType,
                recommended: product.recommended,
                refSeq: product.refSeq,
                selectedAvailability: product.availability, // preselect
                selectedCatalogNumber: product.defaultCatalogNum, // preselect
                selectedSize: product.defaultSize, // preselect
                showInfoIcon: product.showInfoIcon,
                species: product.species,
                taqmanProductID: product.productID, // unique ID for the UI
                threePrimeMost: product.threePrimeMost,
                transcripts: product.transcripts,
                variationID: product.variationID,
                webID: product.webID
            }

            return newProduct;

        });

    }

}
